module.exports = __webpack_public_path__ + "img/ef584f2.png";